/**
 * Reducer for explore trips
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import produce from 'immer'
import merge from 'lodash/merge'
import {
  FETCH_EXPLORE_TRIPS_SUCCESS,
  FETCH_MORE_EXPLORE_TRIPS_SUCCESS,
  FETCH_POPULAR_ITEMS_SUCCESS
} from '../types'

const initialState = {
  boards: {},
  boardsOrder: [],
  popularItems: {}
}

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_EXPLORE_TRIPS_SUCCESS:
      merge(draft, action.data)
      break
    case FETCH_MORE_EXPLORE_TRIPS_SUCCESS:
      const { boardsOrder, ...updatedData } = action.data ?? {}
      const updatedOrder = draft.boardsOrder.concat(boardsOrder)
      updatedData.boardsOrder = updatedOrder

      merge(draft, updatedData)
      break
    case FETCH_POPULAR_ITEMS_SUCCESS:
      const popularItems = action.data
      const boardsArray = popularItems?.boards ?? []
      const popularBoardsOrder = boardsArray.map(({ bid }) => bid)
      const boardsSet = boardsArray.reduce((acc, board) => {
        return {
          ...acc,
          [board.bid]: board
        }
      }, {})

      draft.popularItems = {
        ...popularItems,
        boardsOrder: popularBoardsOrder,
        boardsSet
      }
      break
  }
}, initialState)
